import DetectFieldMappingSaga from './DetectFieldMappingSaga'
import ImporterPreviewSaga, { ExtensionStepDataSaga } from './ImporterStepDataSaga'

export default [DetectFieldMappingSaga, ImporterPreviewSaga, ExtensionStepDataSaga]
